var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"radar-chart-container"},[(_vm.loadedData)?_c('RadarChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"width":500,"height":500}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }